import { PaginationProps } from "../typings";

export const PAGINATION_VALUES: PaginationProps = {
  page_number: 1,
  page_size: 30,
  total_no_of_records: 0,
  total_no_of_pages: 0,
};

export const ROWS_PER_PAGE_OPTIONS = [30, 50, 100]